var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.mode))]),_c('IsBeAuth',{on:{"after-login":function($event){return _vm.afterLogin($event)}}}),_c('div',{staticClass:"main"},[(_vm.login)?_c('ContentsArea',[_c('AppBar'),_c('router-view')],1):_c('ContentsArea',[_c('FileBoxCapacitySkelton')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }